// Generic Lookup Request Type
export interface LookupRequest {
  user_name: string;
  platform: string | null;
  [key: string]: any; // Allow additional fields
}

// Generic Lookup Response Type
export interface LookupResponse {
  data: {
    result_code: string;
    result_msg: string;
    msg_code: string;
    result_data: any[];
  };
  status: number;
  message: string;
}

// Action Types
export const LOOKUP_REQUEST = "LOOKUP_REQUEST";
export const LOOKUP_SUCCESS = "LOOKUP_SUCCESS";
export const LOOKUP_ERROR = "LOOKUP_ERROR";
export const LOOKUP_RESET = "LOOKUP_RESET";

// Lookup Types
export type LookupType = 
  | 'country_code'
  | 'document_pattern'
  | 'itemizer'
  | 'money_text'
  | 'tax_book'
  | 'tax_buyer_type'
  | 'tax_profile_list';

export interface LookupRequestAction {
  type: typeof LOOKUP_REQUEST;
  payload: {
    lookupType: LookupType;
    request: LookupRequest;
  };
}

export interface LookupSuccessAction {
  type: typeof LOOKUP_SUCCESS;
  payload: {
    lookupType: LookupType;
    response: LookupResponse;
  };
}

export interface LookupErrorAction {
  type: typeof LOOKUP_ERROR;
  payload: {
    lookupType: LookupType;
    message: string;
    error?: any;
  };
}

export interface LookupResetAction {
  type: typeof LOOKUP_RESET;
  payload: {
    lookupType: LookupType;
  };
}

export type LookupAction =
  | LookupRequestAction
  | LookupSuccessAction
  | LookupErrorAction
  | LookupResetAction;


